<div class="spinner-container" *ngIf="isBusy">
    <div class="text-center">
        <mat-progress-spinner diameter="120" mode="indeterminate"></mat-progress-spinner>
    </div>
</div>